/**
 * A generic class representing an entity with an immutable ID and mutable properties.
 *
 * @template T - The type of the properties object.
 */
export class Entity<T> {
  private readonly id: string;
  private props: T;

  constructor(props: T, id?: string) {
    this.id = id || crypto.randomUUID();
    this.props = props;
  }

  public getId(): string {
    return this.id;
  }

  public getProps(): T {
    return this.props;
  }

  public updateProps(newProps: Partial<T>): void {
    this.props = { ...this.props, ...newProps };
  }

  public equals(other: Entity<T>): boolean {
    return this.id === other.id;
  }
}
